import { OcrIcon } from './OcrIcon';

/**
 * author: Simran
 * id 2943D362-A548-448C-A868-19E6D37C8B2D
 * name ocr
 * version: 4.4.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/ocr.svg
 * tags
 */
export const OpticalCharacterRecognitionIcon = OcrIcon;
export default OpticalCharacterRecognitionIcon